
import React, { useEffect, useState, useRef, useCallback } from "react";
import cn from "classnames";
import styles from "./ServiceRequest.module.scss";
import Master from "screen/Master";
// import Table from "../../components/common/Table";
import NewTableList from "components/common/NewTableList";
import notificationService from "services/notification.service";
import {
  getRequest,
  putRequest,
  postRequest,
} from "../../services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import { useHistory } from "react-router-dom";
import ServiceRequestViewMaster from "components/common/ServiceRequestViewTableMaster";

var action = "Submit";
var readOnly = false;
var id = undefined;
var view = undefined;
var onlyView = false;
var refIdInput = true
var statusEdit = true


var pageSize = 10;
var pageNumber = 0;
var pagingString = "limit=" + pageSize + "&offset=" + pageNumber;
var tempTigger;

function ServiceListingView(props) {
  const initialFormValues = {
    category: "",
    asset: "",
    reference_Id: "",
    description: "",
    userId:null,
  };

  const history = useHistory();

  const [formErrors, setFormErrors] = useState("");
  const [title, setTitle] = useState("Add Service Request");
  const [formValues, setFormValues] = useState(initialFormValues);
  const [serviceRequestData, setServiceRequestData] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [serviceRequestDataCount, setServiceRequestDataCount] = useState('0');
  const [count, setCount] = useState()


  useEffect(() => {
    id = props?.match?.params?.id;
    view = props?.match?.params?.view;
    if (id !== undefined && view == undefined) {
      action = "Update";
      setTitle("Update Service Request");
      onlyView = false;
      readOnly = true;
      refIdInput = false
      statusEdit = true
      // getSites();

      getRequestDetailByRefernenceId(id);
    } else if (id !== undefined && view !== undefined) {
      action = "view";
      setTitle("View Service Request");
      onlyView = true;
      readOnly = true;
      refIdInput = false
      statusEdit = true
      // getSites();
      getRequestDetailByRefernenceId(id);
    } else {
      // getUnmappedSites();
      setTitle("Add Service Request");
      onlyView = false;
      action = "Submit";
      readOnly = false;
      refIdInput = true
      statusEdit = false
    }
  }, []);

  useEffect(() => {
    getRequestDetailList();
  }, []);

  useEffect(() => {
    getCategoryList();
    getDriverList();
  }, []);

  // const pageLimitHandle = (string, limit) => {
  //   getRequestDetailList( string, limit);
  //   sitePaginationLimt =limit;
  // };


  const getCategoryList = useCallback(async () => {
    await getRequest("requestService/getCategory")
      .then((res) => {
        if (res && res?.data) {
          setCategoryList(res?.data)
        }
      })
  })

  const getDriverList = useCallback(async () => {
    await getRequestInAssets("driver/getAllDriver")
      .then((res) => {
        if (res && res?.data) {
          setDriverList(res?.data)
        }
      })
  })

  const paginationCountHanlde = (offsett, limit, tigger, tempHeaderFilter) => {
     tempTigger = tigger;
     const testCount = tigger == "amhitted" ? 1 : offsett;
     // pageNumber = offsett;
     pageNumber = offsett;
     pageSize = limit;
     pagingString =    "&limit=" + pageSize + "&offset=" + pageNumber;
     getRequestDetailList();
   };

  const getRequestDetailList = useCallback(async () => {
    await getRequest('requestService/getAllServicesRequest?' + pagingString)
      .then((res) => {
        if (res && res.data && res.data.serviceRequestDetailsDtoList.length >= 1) {
          setServiceRequestDataCount(res.data.count);
          setServiceRequestData(res.data.serviceRequestDetailsDtoList);
        }
      })
      .catch((err) => {
        console.error("Error", err);
        if (err) {
          setServiceRequestData([])
        }
      });
  }, []);


  const getRequestDetailByRefernenceId = async (id) => {
    await getRequest(
      `requestService/getRequestDetailsByReference?referenceId=${id}`
    )
      .then((res) => {
        if (res.data != null) {
          patchForm(Array.isArray(res.data) ? res.data[0] : res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const patchForm = (data) => {
    setFormValues({
      category: data.category,
      asset: data.asset,
      reference_Id: data.referenceId,
      description: data.description,
      status: data.status,
      userId: data.userId
    });
  };

  const routeChange = () => {
    history.push({
      pathname: "/ServiceRequest",
      state: {compomentRenderType: "view" },
    });
  }

  const handleCancel = () => {
    routeChange();
    getRequestDetailList();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (e.target.name === "description") {
      const le = value.length;
      setCount(le)
      setFormValues({ ...formValues, [name]: value.replace(/[&*<{$~}>!`^]/g, '') });
    }else{
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const validate = (formValues) => {
    const errors = {};
    if (!formValues.category || formValues.category === "-1") {
      errors.category = "Category is required!";
    } else {
      errors.category = "";
    }

    if (!formValues.userId || formValues.userId === "-1") {
      errors.userId = "Driver is required!";
    } else {
      errors.userId = "";
    }

    if (!formValues.asset || formValues.asset === "-1") {
      errors.asset = "Asset is required!";
    } else {
      errors.asset = "";
    }
    if (id && !formValues.reference_Id) {
      errors.reference_Id = "Reference ID is required!";
    } else {
      errors.reference_Id = "";
    }
      // if (!/^[ A-Za-z0-9-_.&']*$/i.test(formValues.batterySerialNumber)) {
      
    if (formValues.description && formValues.description != "" && (/^[$&+:;=?#|'<>^*()%!]*$/i.test(formValues.description.trim() )) ){
      errors.description =  "-_,@#. are the only allowed special characters!";
    } else {
      errors.description = "";
    }
    setFormErrors(errors);
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues);

    if (Object.values(result).every((x) => x === "")) {
      const obj = {
        category: formValues.category,
        reference_Id: formValues.reference_Id,
        asset: formValues.asset,
        description: formValues.description.trim(),
        status: formValues.status,
        userId: formValues.userId,
      };

      if (action === "Update") {
        // add the update api url
        try {
          putRequest("requestService/updateRequest", obj).then((res) => {
            if (res && res?.data) {
              routeChange();
              notificationService.showNonBlacklisted(res?.config?.url, res?.data?.message);
            }
          })
            .catch(error => {
              console.log(error, "ERROR")
              notificationService.showNonBlacklistedError(error?.config?.url, error?.message);
              return error;
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        // add the add api url
        try {
          postRequest("requestService/addRequest", obj).then((res) => {
            if (res && res?.data) {
              // setServiceRequestData(res.data);
              history.push("/ServiceRequest");
              notificationService.showNonBlacklisted(res?.config?.url, res?.message);
            }
          })
            .catch(error => {
              console.log(error, "ERROR")
              notificationService.showNonBlacklistedError(error?.config?.url, error?.message);
              return error;
            });

        } catch (error) {
          // reset();
          console.log(error);
        }
      }
    }
  };

  var createData = [
    {
      "id": 47,
      "category": "string",
      "reference_Id": "string12",
      "asset": "BATTERY",
      "createdAt": 5657221,
      "updatedAt": 3862732,
      "status": "CREATED",
      "description": "string1223"
    },
  ]

  const viewServiceList = (id) => {
    getRequestDetailByRefernenceId(id)
    history.push(`/ServiceRequest/ViewService/${id}/view`);
    window.location.reload();
  };

  const updateServiceList = (id) => {
    getRequestDetailByRefernenceId(id)
    history.push(`/ServiceRequest/UpdateService/${id}`);
    window.location.reload();
  };

  const columns = React.useMemo(() => [
    {
      Header: "Request ID",
      accessor: "referenceId",
      Cell: (row) => {
        return (
          <div>
            {row.row.values.referenceId ? row.row.values.referenceId : "NA"}
          </div>)
      },
      minWidth: "100px",
    },
    {
      Header: "Category of Issues",
      accessor: "category",
      Cell: (row) => {
        return (
          <div>
            {row.row.values.category ? row.row.values.category : "NA"}
          </div>)
      },
      minWidth: "100px",
    },
    {
      Header: "Driver Email",
      accessor: "driverEmail",
      Cell: (row) => {
        return (
          <div>
            {row.row.values.driverEmail ? row.row.values.driverEmail : "NA"}
          </div>)
      },
      minWidth: "100px",
    },
    {
      Header: "Driver Name",
      accessor: "driverName",
      Cell: (row) => {
        return (
          <div>
            {row.row.values.driverName ? row.row.values.driverName : "NA"}
          </div>)
      },
      minWidth: "100px",
    },
    {
      Header: "Asset",
      accessor: "asset",
      minWidth: "100px",
      Cell: (row) => {
        const asset = row?.row.original?.asset
        if (!asset) return "";
        return asset.split("_").map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(" ")
      }
    },
    {
      Header: "Status",
      accessor: "status",
      minWidth: "100px",
      Cell: (row) => {
        return (
          <>
            {row?.row.original?.status === "CREATED" ? (
              <p className={cn(styles.Status1, styles.Status4)}>
                <span>Created</span>
              </p>
            ) : (
              ""
            )}

            {row?.row.original?.status === "ASSIGNED" ? (
              <p className={cn(styles.Status1, styles.Status6)}>
                <span>Assigned</span>
              </p>
            ) : (
              ""
            )}
            {row?.row.original?.status === "INPROGRESS" ? (
              <p className={cn(styles.Status1, styles.Status3)}>
                <span>Inprogress</span>
              </p>
            ) : (
              ""
            )}
            {row?.row.original?.status === "PENDING" ? (
              <p className={cn(styles.Status1, styles.Status1)}>
                <span>Pending</span>
              </p>
            ) : (
              ""
            )}
            {row?.row.original?.status === "BLOCKED" ? (
              <p className={cn(styles.Status1, styles.Status2)}>
                <span>Blocked</span>
              </p>
            ) : (
              ""
            )}
            {row?.row.original?.status === "CLOSED" ? (
              <p className={cn(styles.Status1, styles.Status5)}>
                <span>Closed</span>
              </p>
            ) : (
              ""
            )}
            {/* {row?.row.original?.status === null ? (
              <p className={cn(styles.Status1, styles.Status2)}>
                <span>Created</span>
              </p>
            ) : (
              ""
            )} */}

          </>
        );
      },
    },
    {
      Header: "Action",
      accessor: "zoneId",
      width: "50px",
      disableSortBy: true,
      Cell: (row) => {
        return (
          <>
            <div>
              <img
                src={require("assets/eye.png").default}
                className={cn(styles.Img)}
                onClick={() => viewServiceList(row.row.original.referenceId)}
              ></img>

              <img
                src={require("assets/pencil.png").default}
                className={cn(styles.Img)}
                onClick={() => updateServiceList(row.row.original.referenceId)}
              ></img>
            </div>
          </>
        );
      },
    },
  ]);

  return (
    <>
      <div className={cn(styles.flex_item1)}>
        <div className={cn(styles.flex1)}>
          <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Service Request"}
          </h2>
          <div className={cn(styles.block1)}>
            <div className={cn(styles.Insideblock1)}>
              <div className={cn(styles.title)}>{title}</div>
              <hr className={cn(styles.line)} />
              <div>
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Category of Issue *"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div>
                        <select
                          className={onlyView ? cn(styles.disable_InputField) : cn(styles.select1)}
                          name="category"
                          value={formValues.category}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">
                            Select category
                          </option>
                          {/* <option value="Category 1" >Category 1</option>
                           <option value="Category 2" >Category 2</option>
                           <option value="Category 3" >Category 3</option>
                           <option value="Category 4" >Category 4</option> */}

                          {categoryList.map((obj) => {
                            return (
                              <option value={obj?.name}>
                                {obj.name}
                              </option>
                            );
                          })}
                          {/* <option value="2" >Site 2</option> */}
                        </select>
                      </div>
                      <p className={cn(styles.error)}>{formErrors.category}</p>
                    </div>
                  </div>
                </div>

                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Select Asset *"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div>
                        <select
                          name="asset"
                          className={readOnly ? cn(styles.disable_InputField) : cn(styles.select1)}
                          value={formValues.asset}
                          onChange={handleChange}
                          disabled={readOnly}
                        >
                          <option value="-1">
                            Select asset
                          </option>
                          <option value="BATTERY">Battery</option>
                          <option value="SWAPSTATION">Swap Station</option>
                          <option value="SITE">Site</option>
                          {/* {createData.map((obj) => {
                            return (
                              <option value={obj.asset}>{obj.asset}</option>
                            );
                          })} */}
                        </select>
                      </div>
                      <p className={cn(styles.error)}>{formErrors.asset}</p>
                    </div>
                  </div>
                </div>

                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Select Driver *"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>

                  <div className={cn(styles.block3, styles.block3_layout)}>
                      <div>
                        <select
                          className={onlyView ? cn(styles.disable_InputField) : cn(styles.select1)}
                          name="userId"
                          value={formValues.userId}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value={null}>
                            Select driver
                          </option>
                          {driverList.map((obj) => {
                            return (
                              <option value={obj?.id}>
                                {obj.name +' ( '+ obj.mobile +' )'}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <p className={cn(styles.error)}>{formErrors.userId}</p>
                    </div>
                  </div>
                </div>

                {
                  !refIdInput ?
                    <div className={cn(styles.flex4, styles.flex4_layout)}>
                      <div className={cn(styles.flex2_item)}>
                        <div className={cn(styles.block3, styles.block3_layout)}>
                          <div
                            className={cn(
                              styles.text1_body,
                              styles.text1_body_layout
                            )}
                          >
                            {"Reference ID *"}
                          </div>
                        </div>
                      </div>

                      <div className={cn(styles.flex4_spacer)} />
                      <div className={cn(styles.flex2_item)}>
                        <div className={cn(styles.block3, styles.block3_layout)}>
                          <div>
                            <input
                              name="reference_Id"
                              value={formValues.reference_Id}
                              onChange={handleChange}
                              className={readOnly ? cn(styles.disable_InputField) : cn(styles.select1)}
                              disabled={readOnly}
                            />
                          </div>
                          <p className={cn(styles.error)}>{formErrors.reference_Id}</p>
                        </div>
                      </div>
                    </div>
                    : ""
                }

                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Description"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div>
                        {/* <div
                          className={cn(
                            styles.text2_body,
                            styles.text2_body_layout
                          )}
                        >
                          {"Battery charging fail"}
                        </div> */}
                        <textarea
                          name="description"
                          value={formValues.description}
                          onChange={handleChange}
                          className={onlyView ? cn(styles.disable_textarea_Field) : cn(styles.select2)}
                          maxLength={200}
                          minLength={30}
                          disabled={onlyView}
                        >
                        </textarea>
                        <div
                          className={cn(
                            styles.text3_body,
                            styles.text3_body_layout
                          )}
                        >
                          {/* {count} Characters maximum 400 characters */}
                          Description should be {count} maximum 200 character

                        </div>
                      </div>
                      <p className={cn(styles.error)}>{formErrors.description}</p>
                    </div>
                  </div>
                </div>

                {
                  statusEdit ?
                    <div className={cn(styles.flex4, styles.flex4_layout)}>
                      <div className={cn(styles.flex2_item)}>
                        <div className={cn(styles.block3, styles.block3_layout)}>
                          <div
                            className={cn(
                              styles.text1_body,
                              styles.text1_body_layout
                            )}
                          >
                            {"Status"}
                          </div>
                        </div>
                      </div>

                      <div className={cn(styles.flex4_spacer)} />
                      <div className={cn(styles.flex2_item)}>
                        <div className={cn(styles.block3, styles.block3_layout)}>
                          <div>
                            <select
                              className={onlyView ? cn(styles.disable_InputField) : cn(styles.select1)}
                              showStatus name="status"
                              value={formValues.status}
                              onChange={handleChange}
                              disabled={onlyView}
                            >
                              <option value="CREATED" >Created</option>
                              <option value="ASSIGNED" >Assigned</option>
                              <option value="INPROGRESS" >Inprogress</option>
                              <option value="PENDING" >Pending</option>
                              <option value="BLOCKED" >Blocked</option>
                              <option value="CLOSED" >Closed</option>

                            </select>
                          </div>
                          <p className={cn(styles.error)}>{formErrors.status}</p>
                        </div>
                      </div>
                    </div> : " "
                }
              </div>

              <div className={cn(styles.flex9, styles.flex9_layout)}>
                <div className={cn(styles.flex9_item)}>
                  <div className={cn(styles.block7, styles.block7_layout)}  onClick={handleCancel} >
                    <h5
                      className={cn(
                        styles.highlights1,
                        styles.highlights1_layout
                      )}
                     
                    >
                      {"Cancel"}
                    </h5>
                  </div>
                </div>
                <div className={cn(styles.flex9_spacer)} />
                {
                  !onlyView ?
                    <div className={cn(styles.flex9_item)}>
                      <div className={cn(styles.block8, styles.block8_layout)}>
                        <h5
                          className={cn(
                            styles.highlights2,
                            styles.highlights2_layout
                          )}
                          onClick={handleSubmit}
                        >
                          {action}
                        </h5>
                      </div>
                    </div> :
                    ''
                }

              </div>
            </div>
          </div>
          {!onlyView && !readOnly && (
            <div className={cn(styles.box16, styles.box16_layout)}>
              <div className={cn(styles.header)}>
                <div className={cn(styles.header1)}>{"Tickets "}</div>

                <div className={cn(styles.Subheader)}>
                  <div className={cn(styles.header2)}>{"Total Tickets : "}</div>

                  <div className={cn(styles.header3)}>
                    {serviceRequestDataCount}
                  </div>
                </div>
              </div>
              {/* <Table columns={columns} data={serviceRequestData} /> */}
              {/* <NewTableList */}
              <ServiceRequestViewMaster
                // pageLimitHandle={pageLimitHandle}
                searchOpts={{
                  // onSearch: searchByKey,
                  // onSearch: searchBySwapStationID,
                  placeholder: "Search by Swapping Station",
                  filter: true,
                  // onFilterSearch: getRequestDetailList,
                  screentype: "swapping",
                }}
              //  tigger={tempTigger}
                headerFilter={props.headerFilter}
                columns={columns}
                data={serviceRequestData}
                paginationDoubleScreen={true}
                swapStationCount={serviceRequestDataCount}
                paginationCountHanlde={paginationCountHanlde}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default function ServiceListing(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1];


  return (
    <>
      <Master
        ServiceListingurl={Urls}
        opts={props}
        screen={ServiceListingView}
        showStatus={true}
      />
    </>
  );
}

ServiceListing.inStorybook = true;
